import React from 'react'
import {
  ModalContainer,
  ModalIcon,
  ModalHeading,
  ModalContent,
  RegisterContainer,
  RegisterContent,
  ModalButton,
} from './Styles'
import { ReactComponent as CrossMark } from 'assets/images/CrossMark.svg'

interface Props {
  handleCloseModal: () => void
}

const ModalLimit = ({handleCloseModal}: Props) => (
  <ModalContainer onClick={(e: React.SyntheticEvent) => e.stopPropagation()}>
    <ModalIcon onClick={handleCloseModal}>
      <CrossMark />
    </ModalIcon>
    <ModalHeading>Limit reached</ModalHeading>
    <ModalContent>
      We are making this service free for everyone, but for now it is only possible with limited
      number of searches per day without registering
    </ModalContent>
    <RegisterContainer>
      <div>
        <RegisterContent>Do you use it for business travel?</RegisterContent>
        <p>Register now and use it without limits!</p>
      </div>
      <ModalButton onClick={handleCloseModal}>Register free</ModalButton>
    </RegisterContainer>
  </ModalContainer>
)

export default ModalLimit
